import { render, staticRenderFns } from "./shipping-form.vue?vue&type=template&id=81e47842&scoped=true&"
import script from "./shipping-form.vue?vue&type=script&lang=js&"
export * from "./shipping-form.vue?vue&type=script&lang=js&"
import style0 from "./shipping-form.vue?vue&type=style&index=0&id=81e47842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e47842",
  null
  
)

export default component.exports